import React from "react";
import { DIGITAL } from "../data/siteData";
import ServicePage from "./ServicePage";

export default function DigitalPage({ onNavigate }) {
  return (
    <ServicePage hero={DIGITAL.hero} onNavigate={onNavigate}>
      <section className="section">
        <div className="capability-grid">
          {DIGITAL.pillars.map((p, i) => (
            <div key={i} className="capability-card">
              <div className="capability-card-header">
                <h4>{p.title}</h4>
                <span className="capability-icon">{p.icon}</span>
              </div>
              <p>{p.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </ServicePage>
  );
}
